import {formatNumber} from "./FormatNumber"


//nhận vào giá trị value
//nếu giá trị value nhỏ hơn 0 thì hiển thị màu đỏ và mũi tên đi xuống
//nếu giá trị value lớn hơn 0 thì hiển thị màu xanh và mũi tên đi lên
export const colorValue = (value) =>{
    if(value > 0){
      return (
        <span className="text-success">
                <i className="bi bi-caret-up-fill" />
                <span>{formatNumber(value)}%</span>
            
        </span>
      )
    }
    else {
        return (
          <span className="text-danger">
                <i className="bi bi-caret-down-fill" />
                <span>{formatNumber(value*(-1))}%</span>
            
          </span>
        )
    }
}